import { dom, library } from '@fortawesome/fontawesome-svg-core'

// fab
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF'
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram'
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter'
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube'

// fas
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight'
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons/faArrowCircleRight'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import { faBaby } from '@fortawesome/free-solid-svg-icons/faBaby'
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import { faComment } from '@fortawesome/free-solid-svg-icons/faComment'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye'
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash'
import { faHandPointRight } from '@fortawesome/free-solid-svg-icons/faHandPointRight'
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
import { faParking } from '@fortawesome/free-solid-svg-icons/faParking'
import { faShuttleVan } from '@fortawesome/free-solid-svg-icons/faShuttleVan'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { faSuitcase } from '@fortawesome/free-solid-svg-icons/faSuitcase'
import { faSwimmingPool } from '@fortawesome/free-solid-svg-icons/faSwimmingPool'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faUserFriends } from '@fortawesome/free-solid-svg-icons/faUserFriends'
import { faWalking } from '@fortawesome/free-solid-svg-icons/faWalking'
import { faWifi } from '@fortawesome/free-solid-svg-icons/faWifi'
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons/faRightFromBracket'

export const iconPack = [
  faFacebook,
  faFacebookF,
  faInstagram,
  faTwitter,
  faYoutube,

  faRightFromBracket,
  faAngleRight,
  faArrowCircleRight,
  faArrowLeft,
  faBaby,
  faBook,
  faCheckCircle,
  faChevronDown,
  faChevronRight,
  faComment,
  faEnvelope,
  faEye,
  faEyeSlash,
  faHandPointRight,
  faLink,
  faMapMarkerAlt,
  faParking,
  faShuttleVan,
  faSpinner,
  faSuitcase,
  faSwimmingPool,
  faTimes,
  faUserFriends,
  faWalking,
  faWifi,
]

library.add(...iconPack)

window.FontAwesomeConfig = {
  searchPseudoElements: true,
  showMissingIcons: process.env.NODE_ENV !== 'production',
}

dom.watch()
